var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.buttonOrLink, {
    tag: "component",
    staticClass: "cm-button",
    class: ( _obj = {
      light: _vm.light
    }, _obj[_vm.size] = true, _obj[_vm.width] = true, _obj ),
    attrs: {
      "v-bind": _vm.$attrs,
      "href": _vm.href
    }
  }, [_vm._t("default")], 2)
  var _obj;
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ed41e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-button.vue
// module id = null
// module chunks = 